
<template>
  <div class="about">
    <div class="banner">
      <img src="@/assets/about/about us.png">
    </div>
    <div class="text inner">
      <p>关于沐之盛</p>
      <p>&mdash;&nbsp;about xiao hong mao&nbsp;&mdash;</p>
    </div>
    <div class="synopsis">
      <img src="@/assets/about/aboutimage.png" alt="">
      <el-carousel arrow='always' indicator-position="outside" trigger="click" :autoplay='false' class="aboutCarousel inner" height="180px">
        <el-carousel-item v-for="item in aboutList" :key="item.id">
          <p>{{item.text1}}</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;{{item.text2}}</p>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="firmPic">
      <el-carousel arrow='always' trigger="click" indicator-position="none" :autoplay='false' class="carousel inner" height="220px">
        <el-carousel-item class="inner" v-for="item in bannerList" :key="item.id">
          <div class="carouselPic">
            <img :src="item.url1" alt>
            <img :src="item.url2" alt>
            <img :src="item.url3" alt>
          </div>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="text inner">
      <p>荣誉与认证</p>
      <p>&mdash;&nbsp;Honor and certification&nbsp;&mdash;</p>
    </div>
    <ul class="honour inner">
      <li v-for="item in honourList" :key="item.id">
        <img :src="item.url" alt="">
        <p>{{item.tit}}</p>
      </li>
    </ul>
    <div class="more"> <a href="">查看更多</a></div>
    <div class="enterprise">
      <div class="inner">
        <div class="text inner">
          <p>企业愿景</p>
          <p>&mdash;&nbsp;Corporate vision&nbsp;&mdash;</p>
        </div>
        <p class="content">围绕传统复印门店距离偏远，营业时间固定，收费偏高等行业通点，针对社区中心，大学，便利店，连锁店，共享办公，办事大厅等高频使用场景重点布局。以提供优质高效打印，复印，扫描服务为基础，沐之盛将引领行业改革新浪潮，用实际行动，重新定义行业发展新趋势！</p>
        <div class="photograph">
          <img v-for="item in photographList" :key="item.id" :src="item.url" alt="">
        </div>
        <p class="future"> &larr;&nbsp;&nbsp;未来，已来！！！&nbsp;&rarr;</p>
      </div>
    </div>
    <footerPage></footerPage>
  </div>
</template>

<script>
import '@/css/about.css'
import '@/css/public.css'
import footerPage from '../components/Footer'
export default {
  components: {
    footerPage,
  },
  data() {
    return {
      aboutList: [
        { id: 1, text1: '郑州沐之盛信息科技有限公司是一家专业从事办公设备销售·租赁·高速文印输出设备的经营和服务，是目前郑州专业从事复印机·高速文印输出设备租赁业务的星级服务企业，多次被夏普·东芝·柯美·震旦·新都·惠普·爱普生等生产厂家评为优秀代理商。', text2: "2007年从事办公设备销售·租赁等传统商务服务以来，产业不断升级，到2017年转型智慧云文印项目运营，十年行业经验积累，使得沐之盛团队具备优于纯软件开发公司的市场运营经验。成熟的商业模式，稳定的软硬件设备投入使用，有力保障了" },
        { id: 2, text1: '郑州沐之盛信息科技有限公司是一家专业从事办公设备销售·租赁·高速文印输出设备的经营和服务，是目前郑州专业从事复印机·高速文印输出设备租赁业务的星级服务企业，多次被夏普·东芝·柯美·震旦·新都·惠普·爱普生等生产厂家评为优秀代理商。', text2: "2007年从事办公设备销售·租赁等传统商务服务以来，产业不断升级，到2017年转型智慧云文印项目运营，十年行业经验积累，使得沐之盛团队具备优于纯软件开发公司的市场运营经验。成熟的商业模式，稳定的软硬件设备投入使用，有力保障了" }
      ],
      bannerList: [
        { id: 1, url1: require("@/assets/about/about7.png"), url2: require("@/assets/about/about8.png"), url3: require("@/assets/about/about9.png") },
        { id: 2, url1: require("@/assets/about/about4.jpg"), url2: require("@/assets/about/about5.jpg"), url3: require("@/assets/about/about6.jpg") }
      ],
      honourList: [
        {
          id: 1, url: require("@/assets/about/aboutcer.png"), tit: '2016年 优秀合作伙伴'
        },
        {
          id: 2, url: require("@/assets/about/aboutcer.png"), tit: '2016年 优秀合作伙伴'
        },

        {
          id: 3, url: require("@/assets/about/aboutcer.png"), tit: '2016年 优秀合作伙伴'
        },

        {
          id: 4, url: require("@/assets/about/aboutcer.png"), tit: '2016年 优秀合作伙伴'
        }
      ],
      photographList: [
        {
          id: 1, url: require("@/assets/about/about1.png")
        },
        {
          id: 2, url: require("@/assets/about/about1.png")
        },

        {
          id: 3, url: require("@/assets/about/about1.png")
        }
      ],
    }
  },
  methods: {
  }
}
</script>
